/* eslint-disable no-unused-vars */
import { memo, useMemo, useState } from 'react';
import { default as DateTimePicker } from 'react-datepicker';
import DatePickerInput from '../datePicker/components/datePickerInput/DatePickerInput';
import { ArrowDropDown } from 'assets/icons';
import { areDatesEqual, formatDate } from 'utils';

const TimePicker = ({
  selectedTime,
  fieldName,
  styledInput,
  minTime,
  maxTime,
  handleChangeTime,
  disabledPicker,
}) => {
  const [isOpen, setIsOpen] = useState('false');
  const handleOpen = () => {
    setIsOpen('true');
  };

  const handleClose = () => {
    setIsOpen('false');
  };
  return (
    <DateTimePicker
      onCalendarClose={handleClose}
      onCalendarOpen={handleOpen}
      onChange={(value) => handleChangeTime(value, fieldName)}
      disabled={disabledPicker(selectedTime) || !selectedTime}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={60}
      minTime={minTime}
      maxTime={maxTime}
      customInput={
        <DatePickerInput
          selected={selectedTime}
          isOpen={isOpen}
          disabled={disabledPicker(selectedTime) || !selectedTime}
          rightIcon={<ArrowDropDown />}
          styledInput={styledInput}
          autoComplete='off'
          placeholderText='HH:MM'
        />
      }
      showPopperArrow={false}
      calendarClassName='timePicker'
      dateFormat='HH:mm'
      timeFormat='HH:mm'
      selected={selectedTime}
      timeCaption=''
    />
  );
};

export default memo(TimePicker);
